// extracted by mini-css-extract-plugin
export default {"wrapper":"pageLoader_wrapper__hTOba","spinner":"pageLoader_spinner__odIPf","spin":"pageLoader_spin__HMIyG","srOnly":"pageLoader_srOnly__3fZcx"};